<small>
  <br>
  <h5 ng-if="showLegenda.length"> Legenda Indicadores </h5>
  <div ng-repeat="indicador in dados.indicadores track by $index">
    <span ng-if="indicador.indicador.tipo=='valor' || indicador.indicador.tipo=='percentual'">
      <span class="indicador-title">{{indicador.indicador.titulo | capitalize}}</span>
      <div class="bar">
        <div ng-if="indicador.equilibrio" class="bg-equilibrio"></div>
        <div ng-if="indicador.alto_equilibrio" class="bg-alto_equilibrio"></div>
        <div ng-if="indicador.numero_faixas >= 2" class="bg-controle"></div>
        <div ng-if="indicador.numero_faixas >= 3" class="bg-alerta"></div>
        <div ng-if="indicador.numero_faixas >= 5" class="bg-extremo"></div>
      </div> 
      <div class="value">
        <div>0</div>
        <div ng-if="indicador.equilibrio > 0">{{indicador.equilibrio}}</div>
        <div ng-if="indicador.alto_equilibrio > 0">{{indicador.alto_equilibrio}}</div>
        <div ng-if="indicador.controle > 0">{{indicador.controle}}</div>
        <div ng-if="indicador.emergencia > 0">{{indicador.emergencia}}</div>
        <div ng-if="indicador.extremo > 0 || indicador.numero_faixas >= 5">{{indicador.extremo}}</div>
      </div>  
      <br><br>
    </span>
  </div>
</small>
